/* eslint-disable linebreak-style */
export const MAINTANANCE_MODE = 0;
export const APPLICATION_TYPES = {
  ALL: 'ALL',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  CANCELLED: 'CANCELLED',
  RETURNED: 'RETURNED',
  EXPIRED: 'EXPIRED',
  DISCHARGED: 'DISCHARGED',
};

// ...........Web URLS
export const WEB_URLS = {
  DEV: 'https://devaccessrp.adgm.com',
  DEV2: 'https://devaccessrp.adgm.com',
  DEV4: 'https://devaccessrp.adgm.com',
  QA4: 'https://devaccessrp.adgm.com',
  DEV3: 'https://devaccessrp.adgm.com',
  QA: 'https://devaccessrp.adgm.com',
  QA2: 'https://devaccessrp.adgm.com',
  QA3: 'https://devaccessrp.adgm.com',
  PROD: 'https://accessrp.adgm.com',
  UAT: 'https://uataccessrp.adgm.com',
  LOCAL: 'http://localhost:9002',
};

export const ACTIVE_WEB_URLS = {
  ACTIVE_WEB_URL: process.env.REACT_APP_ACTIVE_WEB_URL,
};

// ...........Web URLS
export const SMART_BANNER = {
  DEV: '',
  PROD: '',
};

export const ACTIVE_SMART_BANNER = {
  APP_LINK: process.env.NODE_ENV === 'production' ? SMART_BANNER.PROD : SMART_BANNER.DEV,
};

// ...........UAE PASS URLS
export const UAE_PASS_URL = {
  QA: `https://stg-id.uaepass.ae/idshub/authorize?redirect_uri=${ACTIVE_WEB_URLS.ACTIVE_WEB_URL}/login&client_id=adgmaccessrpw_web_stage&response_type=code&state=QXb3nkNTSoEAC5xR&scope=urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId&acr_values=urn:safelayer:tws:policies:authentication:level:low&ui_locales`,
  PROD: `https://id.uaepass.ae/idshub/authorize?redirect_uri=https://accessrp.adgm.com/login&client_id=adgm_accessrp_web_prod&response_type=code&state=PCuk5WrCzkYRuj9V==&scope=urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId&acr_values=urn:safelayer:tws:policies:authentication:level:low&ui_locales`,
  LOGOUT_URL: `https://id.uaepass.ae/idshub/logout?redirect_uri=${ACTIVE_WEB_URLS.ACTIVE_WEB_URL}/login`,
  QA_LOGOUT_URL: `https://stg-id.uaepass.ae/idshub/logout?redirect_uri=${ACTIVE_WEB_URLS.ACTIVE_WEB_URL}/login`,
};

export const ACTIVE_URL_UAE_PASS = {
  BASE_URL_UAE_PASS:
    process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com' ? UAE_PASS_URL.PROD : UAE_PASS_URL.QA,

  BASE_URL_UAE_PASS_LOGOUT:
    process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com'
      ? UAE_PASS_URL.LOGOUT_URL
      : UAE_PASS_URL.QA_LOGOUT_URL,
};
export const BASE_URL_UAE_PASS_LOGOUT_IN_CASE_OF_ERROR = UAE_PASS_URL.LOGOUT_URL_IN_CASE_OF_ERROR;

// Happiness meter aldar url
export const HAPPINESS_METER_FEEDBACK_URLS = {
  CREATE_SESSION: 'https://aldar.eu.qualtrics.com/API/v3/surveys/SV_0iHAhXWLRuhZbca/sessions/',
  POST_FEEDBACK: 'https://aldar.eu.qualtrics.com/API/v3/surveys/SV_0iHAhXWLRuhZbca/sessions/',
};
// ...........Clever Tap keys
export const CLEVER_TAP_KEYS = {
  DEV_KEYS: 'TEST-Z65-666-K46Z',
  PROD_KEYS: 'W65-666-K46Z',
};

export const ACTIVE_KEY = {
  BASE_KEY:
    process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com'
      ? CLEVER_TAP_KEYS.PROD_KEYS
      : CLEVER_TAP_KEYS.DEV_KEYS,
};

// ...........API URLS
export const API_URLS = {
  DEV_URL: 'https://apidevaccessrp.adgm.com',
  DEV_URL2: 'https://apidevaccessrp.adgm.com',
  DEV4_URL: 'https://apidevaccessrp.adgm.com',
  QA4_URL: 'https://apidevaccessrp.adgm.com',
  QA_URL: 'https://apidevaccessrp.adgm.com',
  PROD_URL: 'https://apidevaccessrp.adgm.com',
  UAT_URL: 'https://apidevaccessrp.adgm.com',
  DOTNET_DEV_URL: 'https://apidevaccessrp.adgm.com',
  DOTNET_QA_URL: 'https://apidevaccessrp.adgm.com',
};

export const ACTIVE_URL = {
  BASE_URL: process.env.REACT_APP_ACTIVE_API_URL,
};

// ...........PowerBI URLS Staging
export const REPORTS_ID = {
  HOME_ID_EN: '8619c456-1467-4cb0-8e8d-09102acec3e4',
  HOME_ID_AR: 'c6ccbf61-aef8-42ed-9bac-fb5efc984de9',
  HOME_MOBILE_ID_EN: 'ca7776aa-b249-42fa-bc75-9b0f6484308e',
  HOME_MOBILE_ID_AR: 'bd51a104-2dfc-4124-a14f-43f22781e0ed',

  TRANSACTION_SALE_ID_EN: 'f27edbc7-7756-490c-aa95-fe29bfd672ef',
  TRANSACTION_SALE_ID_AR: 'c1da6c95-c8e6-4a21-935f-bff39afa08d2',
  TRANSACTION_MORTGAGE_ID_EN: '9678e4e6-3b70-4a94-9311-9a7888a8dfaa',
  TRANSACTION_MORTGAGE_ID_AR: '123d02bb-0535-4d95-8af3-6a2aaaae03d4',
  // TRANSACTION_RENT_ID_EN: '7c308514-bf1a-48e7-980f-f67c26079358',
  // TRANSACTION_RENT_ID_AR: '5c6fd93e-8a46-488a-84db-f4fecea08e05',

  AVERAGE_SALE_ID_EN: '2e567f07-6e19-4652-bab2-4121641a0654',
  AVERAGE_SALE_ID_AR: 'a4882fae-89e6-49e5-b744-114bac8cb449',
  AVERAGE_RENT_ID_EN: 'a1c08c6f-5ac9-4494-8fc1-59545bc4f405',
  AVERAGE_RENT_ID_AR: 'c667e5b9-aaa5-4631-bbe4-98f8048935dc',

  INDICES_SALE_ID_EN: '939ab7af-abc9-41e6-a150-de160b3123d9',
  INDICES_SALE_ID_AR: '7b3f5e0f-3fdc-41a8-8d49-42d02fcff022',

  SALE_TRASACTION: '7c78a50c-56d4-4ae8-b093-754301f68d93',
  SALE_TRASACTION_AR: 'f26add0c-3b09-4e69-b326-fd5fd02f2b45',
};
// ...........PowerBI URLS Staging
export const REPORTS_ID_PROD = {
  HOME_ID_EN: 'ea806165-5504-4a21-8fa6-e0f538cd8f5a',
  HOME_ID_AR: 'afd7d272-e8a6-4f7c-aab0-931f645558b9',

  HOME_MOBILE_ID_EN: '5547ba0a-334a-4ba7-ab3d-c84a6e62da30',
  HOME_MOBILE_ID_AR: '7948a08e-b7e8-4b7b-95e9-f8b7188983f3',

  TRANSACTION_SALE_ID_EN: '69dd24b8-a512-4ef5-a766-1cd0548573d7',
  TRANSACTION_SALE_ID_AR: 'c0656d3f-ea38-4439-a893-cb5001564ba8',

  TRANSACTION_MORTGAGE_ID_EN: 'f2bd0068-6820-4c14-ad88-34e47d78fed4',
  TRANSACTION_MORTGAGE_ID_AR: '4de745cd-496c-41a6-92e8-ef2ca99cb876',

  AVERAGE_SALE_ID_EN: 'a168feca-14ef-46f3-90d7-bddeeacfd5aa',
  AVERAGE_SALE_ID_AR: 'dd859c33-fcc5-45c0-84fb-834d4f7b7ab7',

  AVERAGE_RENT_ID_EN: 'a1f60fbf-2428-4fc7-be60-81c4f35cb3bb',
  AVERAGE_RENT_ID_AR: '40b7957b-2f03-4d5f-a3a6-3d6e3ef5ddfb',

  INDICES_SALE_ID_EN: '9415d7b5-b82b-49a0-98a8-44d96f6aad19',
  INDICES_SALE_ID_AR: '116e2809-569e-4415-a451-eab3366f2f04',

  SALE_TRASACTION: 'b08213e4-05e2-4366-a9ae-239576a8d019',
  SALE_TRASACTION_AR: 'c3233c53-2540-41e2-865d-3f1f24e92bd2',
};

const ACTIVE_REPORTS_ID_KEYS =
  process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com' ? REPORTS_ID_PROD : REPORTS_ID;

export const ACTIVE_REPORTS_ID = {
  HOME_EN_ID: ACTIVE_REPORTS_ID_KEYS.HOME_ID_EN,
  HOME_AR_ID: ACTIVE_REPORTS_ID_KEYS.HOME_ID_AR,
  HOME_MOBILE_EN_ID: ACTIVE_REPORTS_ID_KEYS.HOME_MOBILE_ID_EN,
  HOME_MOBILE_AR_ID: ACTIVE_REPORTS_ID_KEYS.HOME_MOBILE_ID_AR,
  TRANSACTION_SALE_ID_EN: ACTIVE_REPORTS_ID_KEYS.TRANSACTION_SALE_ID_EN,
  TRANSACTION_SALE_ID_AR: ACTIVE_REPORTS_ID_KEYS.TRANSACTION_SALE_ID_AR,
  TRANSACTION_MORTGAGE_ID_EN: ACTIVE_REPORTS_ID_KEYS.TRANSACTION_MORTGAGE_ID_EN,
  TRANSACTION_MORTGAGE_ID_AR: ACTIVE_REPORTS_ID_KEYS.TRANSACTION_MORTGAGE_ID_AR,
  // TRANSACTION_RENT_ID_EN: ACTIVE_REPORTS_ID_KEYS.TRANSACTION_RENT_ID_EN,
  // TRANSACTION_RENT_ID_AR:  ACTIVE_REPORTS_ID_KEYS.TRANSACTION_RENT_ID_AR,
  AVERAGE_SALE_ID_EN: ACTIVE_REPORTS_ID_KEYS.AVERAGE_SALE_ID_EN,
  AVERAGE_SALE_ID_AR: ACTIVE_REPORTS_ID_KEYS.AVERAGE_SALE_ID_AR,
  AVERAGE_RENT_ID_EN: ACTIVE_REPORTS_ID_KEYS.AVERAGE_RENT_ID_EN,
  AVERAGE_RENT_ID_AR: ACTIVE_REPORTS_ID_KEYS.AVERAGE_RENT_ID_AR,
  INDICES_SALE_ID_EN: ACTIVE_REPORTS_ID_KEYS.INDICES_SALE_ID_EN,
  INDICES_SALE_ID_AR: ACTIVE_REPORTS_ID_KEYS.INDICES_SALE_ID_AR,

  SALE_TRASACTION: ACTIVE_REPORTS_ID_KEYS.SALE_TRASACTION,
  SALE_TRASACTION_AR: ACTIVE_REPORTS_ID_KEYS.SALE_TRASACTION_AR,
};

// ...........FRESH DESK HELP URLS
export const FRESH_DESK_URL = {
  HELP_URL: `https://help.adgm.com`,
  ABOUT_URL: `https://help.adgm.com`,
};

export const URLS = {
  CLIENT_DEV_URL: 'http://localhost:9002',
  CLIENT_PROD_URL: 'https://devaccessrp.adgm.com',
  CLIENT_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:9002' : 'https://devaccessrp.adgm.com',
};

export const COMPONENT_TYPES = {
  PMA_SELECT_PROPERTIES: 'pma-select-properties',
  LEASE_REGISTRATION: 'lease_registration',
  PROPERTIES: 'properties',
};

export const applicationTypes = {
  LEASE_REGISTRATION: 'LEASE_REGISTRATION',
  SELL_PURCHASE: 'SELL_PURCHASE',
  ADD_COMPANY: 'ADD_COMPANY',
  ADD_POA: 'ADD_POA',
  ADD_EMPLOYEE: 'ADD_COMPANY_EMPLOYEE',
  UPDATE_COMPANY: 'UPDATE_COMPANY',
  CERT_PROP_OWNERSHIP: 'CERT_PROP_OWNERSHIP',
  CERT_TITLE_DEED_PLOT: 'CERT_TITLE_DEED_PLOT',
  CERT_TITLE_DEED_UNIT: 'CERT_TITLE_DEED_UNIT',
  CERT_SITE_PLAN_PLOT: 'CERT_SITE_PLAN_PLOT',
  CERT_SITE_PLAN_UNIT: 'CERT_SITE_PLAN_UNIT',
  CERT_VERIFICATION_PLOT: 'CERT_VERIFICATION_PLOT',
  CERT_VERIFICATION_UNIT: 'CERT_VERIFICATION_UNIT',
  REQUEST_VALUATION_CERTIFICATE_LAND: 'REQUEST_VALUATION_CERTIFICATE_LAND',
  REQUEST_VALUATION_CERTIFICATE_UNIT: 'REQUEST_VALUATION_CERTIFICATE_UNIT',
};

export const workflowIds = {
  LEASE_REGISTRATION: 'LEASE_REGISTRATION',
  SELL_PURCHASE: 'SELL_PURCHASE_ONLINE',
  ADD_COMPANY: 'ADD_COMPANY_ONLINE',
  ADD_POA: 'ADD_POA_ONLINE',
};

export const cardTypes = {
  DEFAUTL: 'PropertyDefCard',
  RADIO: 'PropertyRadioCard',
  CHECKBOX: 'PropertyCheckboxCard',
};

export const propertyCardTypes = {
  DEFAULT: 'DEFAULT',
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
};

export const propertySwitchTypes = {
  LEASE: 'LEASE',
  OWNERSHIP: 'OWNERSHIP',
  MORTGAGE: 'MORTGAGE',
  PROPERTY: 'PROPERTY',
  PROJECT: 'PROJECT',
  CERTIFICATE: 'CERTIFICATE',
};

export const propertyTypes = {
  OFF_PLAN_LAND: 1,
  OFF_PLAN_UNIT: 4,
  MORTGAGE_LAND: 1,
  MORTGAGE_UNIT: 4,
};

export const defaultDataToFetchOwnership = {
  communityID: null,
  districtID: null,
  emiratesID: null,
  isBlocked: null,
  isMortgaged: null,
  lang: 1,
  licenseNo: null,
  municipalityID: null,
  noOfRoom: null,
  ownerIDs: null,
  ownerShipTypeID: null,
  ownerType: 1,
  pageNumber: 1,
  pageSize: 10,
  plotAllocationTypeID: null,
  plotNumber: null,
  roadID: null,
  unifiedNumber: null,
  propertyType: null,
};

export const defaultDataToFetchLease = {
  bedrooms: [],
  blocked: null,
  buildingId: null,
  buildingNumber: null,
  communityID: null,
  districtID: null,
  floorNumber: null,
  isBlocked: null,
  landUseID: null,
  municipalityID: null,
  orderBy: null,
  orderByDirection: 1,
  pageNumber: 1,
  pageSize: 10,
  plotNumber: null,
  poAProperties: null,
  propertyRegNo: null,
  propertyType: 100,
  propertyTypeId: null,
  propertyUseId: null,
  rentStatus: null,
  roadID: null,
  unitNumber: null,
  unitRegNo: null,
  unitTypeId: null,
  unitUseID: null,
};

export const currencyMaskOption = {
  prefix: 'AED',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  // decimalLimit: 2,
  // integerLimit: 7,
  allowNegative: false,
  allowLeadingZeroes: false,
};
export const percentageMaskOption = {
  prefix: '',
  suffix: '',
  allowDecimal: true,
  decimalSymbol: '.',
  includeThousandsSeparator: false,
  allowNegative: false,
  allowLeadingZeroes: false,
  decimalLimit: 2,
  integerLimit: 3,
};
export const CommaSeparatedWithoutCurrency = {
  prefix: '',
  suffix: '',
  allowDecimal: true,
  decimalSymbol: '.',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
};
export const numberMaskOption = {
  prefix: '',
  suffix: '',
  allowDecimal: false,
  decimalSymbol: '.',
  includeThousandsSeparator: false,
};
export const numberMaskWithoutDecimalOption = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: false,
  allowLeadingZeroes: true,
};

export const numberMaskForEIDOrUN = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: false,
  allowLeadingZeroes: true,
  integerLimit: 15,
};
export const formatPhoneNumber = input => {
  // Remove all non-digit characters
  const digits = input.replace(/\D/g, '');

  // Build the formatted number based on the length of the digits
  const phoneNumberLength = digits.length;

  if (phoneNumberLength === 0) {
    return '';
  }
  return `+${digits.slice(0, 16)}`;
};
export const phoneMask = [
  '+',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const eidMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

// ...................... dev
const firebaseConfigDev = {
  apiKey: '',
  authDomain: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  appId: '',
  measurementId: '',
};
// .......................... prod
const firebaseConfigProd = {
  apiKey: '',
  authDomain: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  appId: '',
  measurementId: '',
};

export const firebaseConfig = process.env.NODE_ENV === 'production' ? firebaseConfigProd : firebaseConfigDev;

// ...................... dev
export const flags = {
  longLease: 10,
  waiver: 4,
  OffPlan: 4,
};

export const mortgageBankMakerFormKeys = {
  amount: 'mortgageAmount',
  startDate: 'startDate',
  endDate: 'endDate',
  type: 'mortgageTypeId',
  contractNumber: 'contractNumber',
  signatory: 'bankSignatoryId',
  valuationCompany: 'valuatorCompanyId',
  valuator: 'valuatorUserId',
};

export const applicationActions = {
  success: 'SUCCESS',
  reject: 'REJECT',
  terminate: 'TERMINATE',
  refuse: 'REFUSE',
};

export const mortgageApplicationStatuses = {
  ownerReview: 'OWNER_REVIEW',
  makerReview: 'MAKER_REVIEW',
  checkerReview: 'CHECKER_REVIEW',
  dmtReview: 'MUNICIPALITY_REVIEW',
  ownerReturn: 'OWNER_RETURN',
  makerReturn: 'MAKER_RETURN',
  checkerReturn: 'CHECKER_RETURN',
  dmtReturn: 'MUNICIPALITY_RETURN',
};
// ...........TEMPLATE URLS
export const TEMPLATE_URLS = {
  UNIFIED_SPA_DEV: 'https://strgdaritemplates.blob.core.windows.net/templates/Unified%20SPA_V2.pdf',
};

export const ACTIVE_TEMPLATE_URL = {
  UNIFIED_SPA: TEMPLATE_URLS.UNIFIED_SPA_DEV,
};

export const SERVICE_ADGM = {
  AUTH_KEY: '',
  URL_EN: 'https://services.accessrp.adgm.com/wp-json/adgm/v1/posts/219',
  URL_AR: 'https://services.accessrp.adgm.com/wp-json/adgm/v1/posts/221',
};

export const professionLicenseServices = {
  'broker-individual': 'REQUEST_LICENCE_BROKER_INDIVIDUAL',
  'broker-employee': 'REQUEST_LICENCE_BROKER_EMPLOYEE',
  'broker-company': 'REQUEST_LICENCE_BROKER_COMPANY',
  'primary-developer': 'REQUEST_LICENCE_PRIMARY_DEVELOPER',
  'secondary-developer': 'REQUEST_LICENCE_SECONDARY_DEVELOPER',
  'account-trustee': 'REQUEST_LICENCE_ACCOUNT_TRUSTEE',
  'auctioneer-company': 'REQUEST_LICENCE_AUCTIONEER_COMPANY',
  'auctioneer-employee': 'REQUEST_LICENCE_AUCTIONEER_EMPLOYEE',
  'evaluator-company': 'REQUEST_LICENCE_EVALUATOR_COMPANY',
  'evaluator-employee': 'REQUEST_LICENCE_EVALUATOR_EMPLOYEE',
  'surveyor-company': 'REQUEST_LICENCE_SURVEYOR_COMPANY',
  'surveyor-employee': 'REQUEST_LICENCE_SURVEYOR_EMPLOYEE',
};

export const licenseServicesHavePayment = ['REQUEST_LICENCE_BROKER_COMPANY', 'REQUEST_LICENCE_PRIMARY_DEVELOPER'];

export const permitServices = {
  'offplan-sale-advertisement-permit-issuance': 'REQUEST_OFFPLAN_ADVERTISEMENT_PERMIT',
  'offplan-sale-marketing-permit-issuance': 'REQUEST_OFFPLAN_MARKETING_PERMIT',
  'project-launch-permit-issuance': 'REQUEST_PROJECT_LAUNCH_EVENT_PERMIT',
  'local-exhibition-permit-issuance': 'REQUEST_LOCAL_EXHIBITION_PERMIT',
  'international-exhibition-permit-issuance': 'REQUEST_INTERNATIONAL_EXHIBITION_PERMIT',
};

// Don't change sequence conditions applied on the basis
export const permitsHaveEventLaunchDetails = [
  'REQUEST_LOCAL_EXHIBITION_PERMIT',
  'REQUEST_INTERNATIONAL_EXHIBITION_PERMIT',
];

export const pmaServices = {
  PMA_RENEWAL: 'PMA_RENEWAL',
  PMA_AMENDMENT: 'PMA_AMENDMENT',
  PMA_REGISTRATION: 'PMA_REGISTRATION',
};

export const pmaServicesByPath = {
  'pma-renew': 'PMA_RENEWAL',
  'pma-amendment': 'PMA_AMENDMENT',
  'pma-registration': 'PMA_REGISTRATION',
  'pma-cancellation': 'PMA_CANCELLATION',
};

export const INSANT_SERVICES_TYPES = [
  'REGISTER_CAVEAT',
  'EASEMENT_RELEASE',
  'REVOKE_AUTHORITY',
  'REGISTER_COVENANT',
  'REGISTER_EASEMENT',
  'REGISTER_MORTGAGE',
  'TRANSFER_PROPERTY',
  'OFFPLAN_TERMINATION',
  'MAINTAIN_FILE_NOTES',
  'PROJECT_REGISTRATION',
  'REGISTER_COVENANT_RELEASE',
  'REGISTER_VARIATION_MORTGAGE',
  'REGISTER_DISCHARGE_MORTGAGE',
  'REGISTER_WITHDRAWAL_OF_CAVEAT',
  'TRANSFER_OFFPLAN_TO_COMPLETED',
  'PROJECT_ACCOUNT_BANK_REGISTRATION',
  'PROJECT_ACCOUNT_AGREEMENT_REGISTRATION',
  'VARIATION_OR_EXTINGUISHING_OF_COVENANTS',
  'RESERVATION_AGREEMENT_REGISTRATION',
  'ISSUE_VALUATION_CERTIFICATE',
  'REGISTER_LONG_LEASE_PLOT',
  'LONG_LEASE_SURRENDER',
  'REGISTER_RENEW_DEVELOPER',
  'RELEASE_FUNDS_FOR_DEVELOPMENT_COSTS',
  'RELEASE_PROFITS_BEFORE_BUILDING_COMPLETION',
  'RELEASE_PROFITS_AFTER_BUILDING_COMPLETION',
  'OFFPLAN_MARKETING_REQUEST',
  'ADVERTISING_PERMIT_REQUEST',
];

export const LIST_OF_INSTANT_SERVICES_SLUGS = [
  'register-caveat',
  'easement-release',
  'revoke-authority',
  'register-covenant',
  'register-easement',
  'transfer-property',
  'register-mortgage',
  'maintain-file-notes',
  'offplan-termination',
  'register-covenant-release',
  'register-variation-mortgage',
  'register-discharge-mortgage',
  'register-withdrawal-of-caveat',
  'transfer-offplan-to-completed',
  'project-account-bank-registration',
  'project-account-agreement-registration',
  'variation-or-extinguishing-of-covenants',
  'offplan-marketing-request',
  'register-long-lease-plot',
  'long-lease-surrender',
  'register-renew-developer',
  'release-funds-for-development-costs',
  'release-profits-after-building-completion',
  'release-profits-before-building-completion',
  'offplan-marketing-request',
  'advertising-permit-request',
  'reservation-agreement-registration',
];

export const SERVICE_TYPES = {
  'register-caveat': 'REGISTER_CAVEAT',
  'revoke-authority': 'REVOKE_AUTHORITY',
  'easement-release': 'EASEMENT_RELEASE',
  'transfer-property': 'TRANSFER_PROPERTY',
  'register-mortgage': 'REGISTER_MORTGAGE',
  'register-covenant': 'REGISTER_COVENANT',
  'register-easement': 'REGISTER_EASEMENT',
  'offplan-termination': 'OFFPLAN_TERMINATION',
  'maintain-file-notes': 'MAINTAIN_FILE_NOTES',
  'project-registration': 'PROJECT_REGISTRATION',
  'register-covenant-release': 'REGISTER_COVENANT_RELEASE',
  'register-variation-mortgage': 'REGISTER_VARIATION_MORTGAGE',
  'register-discharge-mortgage': 'REGISTER_DISCHARGE_MORTGAGE',
  'register-withdrawal-of-caveat': 'REGISTER_WITHDRAWAL_OF_CAVEAT',
  'project-account-bank-registration': 'PROJECT_ACCOUNT_BANK_REGISTRATION',
  'project-account-agreement-registration': 'PROJECT_ACCOUNT_AGREEMENT_REGISTRATION',
  'variation-or-extinguishing-of-covenants': 'VARIATION_OR_EXTINGUISHING_OF_COVENANTS',
  'transfer-offplan-to-completed': 'TRANSFER_OFFPLAN_TO_COMPLETED',
  'register-long-lease-plot': 'REGISTER_LONG_LEASE_PLOT',
  'long-lease-surrender': 'LONG_LEASE_SURRENDER',
  'register-renew-developer': 'REGISTER_RENEW_DEVELOPER',
  'issue-valuation-certificate': 'ISSUE_VALUATION_CERTIFICATE',
  'release-funds-for-development-costs': 'RELEASE_FUNDS_FOR_DEVELOPMENT_COSTS',
  'release-profits-after-building-completion': 'RELEASE_PROFITS_AFTER_BUILDING_COMPLETION',
  'release-profits-before-building-completion': 'RELEASE_PROFITS_BEFORE_BUILDING_COMPLETION',
  'offplan-marketing-request': 'OFFPLAN_MARKETING_REQUEST',
  'advertising-permit-request': 'ADVERTISING_PERMIT_REQUEST',
  'reservation-agreement-registration': 'RESERVATION_AGREEMENT_REGISTRATION',
};

export const LIST_OF_INSTANT_SERVICES_SLUGS_SELECTION = ['project-registration', 'issue-valuation-certificate'];

export const ALL_INSTANT_SERVICES_SLUGS = [
  ...LIST_OF_INSTANT_SERVICES_SLUGS,
  ...LIST_OF_INSTANT_SERVICES_SLUGS_SELECTION,
];

export const CERTIFICATES_SERVICES_SLUGS = [
  'issue-title-deed-land',
  'issue-title-deed-unit',
  'issue-verification-certificate-land',
  'issue-verification-certificate-unit',
  'issue-site-plan',
  'issue-ownership-certificate',
];
